import { Navigate } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";
import { FiEdit3, FiLayers, FiLink, FiMessageCircle, FiUploadCloud } from "react-icons/fi";
import ErrorPage from "./error-page";
import OperationalUserDetails from "./feature/Admin/List/OperationalUserDetails";
import { CreateShortUrlScreen } from "./feature/create/CreateScreen";
import { ViewShortUrl } from "./feature/details/DetailsScreen";
import { BulkUploadScreen } from "./feature/bulk/BulkUploadScreen";
import BulkUploadHistoryScreen from "./feature/bulk/BulkUploadHistoryScreen";
import AllDataScreen from "./feature/list/AllDataScreen";
import { ListShortUrls } from "./feature/list/ListScreen";
import { Redirector } from "./feature/redirector/Redirector";
import WhatsappStatsScreen from "./feature/Whatsapp/WhatsappStatsScreen";
import { WrongPlace } from "./wrong-place";
import CampaignListScreen from "./feature/campaigns/CampaignListScreen";
import CampaignAnalyticsScreen from "./feature/campaigns/CampaignAnalyticsScreen";

const route_operational = [
  {
    hidden: true,
    path: "/dashboard",
    element: <Navigate to="/list" replace />,
    errorElement: <ErrorPage />,
    name: "Dashboard",
  },
  {
    path: "/create",
    element: <CreateShortUrlScreen />,
    errorElement: <ErrorPage />,
    name: "Create",
    icon: <FiEdit3 size={20} strokeWidth={2.25} />
  },
  {
    path: "/bulk-upload",
    element: <BulkUploadScreen />,
    errorElement: <ErrorPage />,
    name: "Bulk Upload",
    icon: <FiUploadCloud size={20} strokeWidth={2.25} />
  },
  {
    hidden: true,
    path: "/bulk-uploads",
    element: <BulkUploadHistoryScreen />,
    errorElement: <ErrorPage />,
    name: "Upload History",
    icon: <FiUploadCloud size={20} strokeWidth={2.25} />
  },
  {
    path: "/list",
    element: <ListShortUrls />,
    errorElement: <ErrorPage />,
    name: "ShortLinks",
    icon: <FiLink size={20} strokeWidth={2.25} />
  },
  {
    path: "/campaigns",
    element: <CampaignListScreen />,
    errorElement: <ErrorPage />,
    name: "Campaigns",
    icon: <FiLayers size={20} strokeWidth={2.25} />
  },
  {
    hidden: true,
    path: "/campaigns/:id",
    element: <CampaignAnalyticsScreen />,
    errorElement: <ErrorPage />,
    name: "Campaign Analytics",
    icon: <FiLayers size={20} strokeWidth={2.25} />
  },
  {
    hidden:true,
    path: "/lists",
    element: <AllDataScreen />,
    errorElement: <ErrorPage />,
    name: "Shortlinks",
    icon: <FiLink size={20} strokeWidth={2.25} />
  },
  {
    hidden: true,
    path: "/list/view/:short_code",
    element: <ViewShortUrl />,
    errorElement: <ErrorPage />,
    name: "Shortlinks",
    icon: '😸'
  },
  {
    hidden: true,
    path: "/:short_code",
    element: <Redirector />,
    errorElement: <ErrorPage />,
    name: "Redirector",
    icon: '😸'
  },
  {
    hidden: true,
    path: "/:client_id/:short_code",
    element: <Redirector />,
    errorElement: <ErrorPage />,
    name: "Redirector",
    icon: '😸'
  },
  {
    hidden: true,
    path: "/",
    element: <WrongPlace />,
    errorElement: <ErrorPage />,
    name: "Error",
    icon: '🚫'
  },
  {
    hidden: true,
    path: "/whatsapp",
    element: <WhatsappStatsScreen />,
    errorElement: <ErrorPage />,
    name: "Whatsapp",
    icon: <FiMessageCircle size={20} strokeWidth={2.25} />
  },
  {
    hidden: true,
    path: "/logout",
    element: <AiOutlineLogout />,
    errorElement: <ErrorPage />,
    name: "Logout",
    icon: '🚫'
  },
  {
    hidden: true,
    path: "/operational-user/:id",
    element: <OperationalUserDetails />,
    errorElement: <ErrorPage />,
    name: "Operational",
  },

]

export default route_operational;
